var mr = (function(a, b, c) {
    'use strict';
    function d(b) {
        (b = 'undefined' == typeof b ? a : b),
            g.documentReady.concat(g.documentReadyDeferred).forEach(function(a) {
                a(b);
            });
    }
    function e(b) {
        (b = 'object' == typeof b ? a : b),
            g.windowLoad.concat(g.windowLoadDeferred).forEach(function(a) {
                a(b);
            });
    }
    var f = {},
        g = {
            documentReady: [],
            documentReadyDeferred: [],
            windowLoad: [],
            windowLoadDeferred: []
        };
    return (
        a(c).ready(d),
        a(b).load(e),
        (f.setContext = function(b) {
            var c = a;
            return 'undefined' != typeof b
                ? function(c) {
                      return a(b).find(c);
                  }
                : c;
        }),
        (f.components = g),
        (f.documentReady = d),
        (f.windowLoad = e),
        f
    );
})(jQuery, window, document);
(mr = (function(a, b, c, d) {
    'use strict';
    return (
        (a.util = {}),
        (a.util.requestAnimationFrame =
            c.requestAnimationFrame ||
            c.mozRequestAnimationFrame ||
            c.webkitRequestAnimationFrame ||
            c.msRequestAnimationFrame),
        (a.util.documentReady = function(a) {
            var b = new Date(),
                c = b.getFullYear();
            a('.update-year').text(c);
        }),
        (a.util.getURLParameter = function(a) {
            return (
                decodeURIComponent(
                    (new RegExp('[?|&]' + a + '=([^&;]+?)(&|#|;|$)').exec(location.search) || [
                        void 0,
                        ''
                    ])[1].replace(/\+/g, '%20')
                ) || null
            );
        }),
        (a.util.capitaliseFirstLetter = function(a) {
            return a.charAt(0).toUpperCase() + a.slice(1);
        }),
        (a.util.slugify = function(a, b) {
            return 'undefined' != typeof b
                ? a.replace(/ +/g, '')
                : a
                      .toLowerCase()
                      .replace(/[^\w ]+/g, '')
                      .replace(/ +/g, '-');
        }),
        (a.util.sortChildrenByText = function(a, c) {
            var d = b(a),
                e = d.children().get(),
                f = -1,
                g = 1;
            'undefined' != typeof c && ((f = 1), (g = -1)),
                e.sort(function(a, c) {
                    var d = b(a).text(),
                        e = b(c).text();
                    return e > d ? f : d > e ? g : 0;
                }),
                d.empty(),
                b(e).each(function(a, b) {
                    d.append(b);
                });
        }),
        (a.util.idleSrc = function(a, c) {
            c = 'undefined' != typeof c ? c : '';
            var d = a.is(c + '[src]') ? a : a.find(c + '[src]');
            d.each(function(a, c) {
                c = b(c);
                var d = c.attr('src'),
                    e = c.attr('data-src');
                'undefined' == typeof e && c.attr('data-src', d), c.attr('src', '');
            });
        }),
        (a.util.activateIdleSrc = function(a, c) {
            c = 'undefined' != typeof c ? c : '';
            var d = a.is(c + '[src]') ? a : a.find(c + '[src]');
            d.each(function(a, c) {
                c = b(c);
                var d = c.attr('data-src');
                'undefined' != typeof d && c.attr('src', d);
            });
        }),
        (a.util.pauseVideo = function(a) {
            var c = a.is('video') ? a : a.find('video');
            c.each(function(a, c) {
                var d = b(c).get(0);
                d.pause();
            });
        }),
        a.components.documentReady.push(a.util.documentReady),
        a
    );
})(mr, jQuery, window, document)),
    (mr = (function(a, b, c, d) {
        'use strict';
        (a.scroll = {}), (a.scroll.listeners = []), (a.scroll.y = 0), (a.scroll.x = 0);
        var e = function(b) {
            b('body').hasClass('scroll-assist') && (a.scroll.assisted = !0),
                addEventListener(
                    'scroll',
                    function(a) {
                        (c.mr.scroll.y = c.pageYOffset), c.mr.scroll.update(a);
                    },
                    !1
                );
        };
        return (
            (a.scroll.update = function(b) {
                for (var c = 0, d = a.scroll.listeners.length; d > c; c++) a.scroll.listeners[c](b);
            }),
            (a.scroll.documentReady = e),
            a.components.documentReady.push(e),
            a
        );
    })(mr, jQuery, window, document)),
    (mr = (function(a, b, c, d) {
        'use strict';
        var e = function(a) {
            a('.accordion__title').on('click', function() {
                var b = a(this).closest('.accordion'),
                    c = a(this).closest('li');
                if (c.hasClass('active')) c.removeClass('active');
                else if (b.hasClass('accordion--oneopen')) {
                    var d = b.find('li.active');
                    d.removeClass('active'), c.addClass('active');
                } else c.addClass('active');
            }),
                a('.accordion').each(function() {
                    var b = a(this),
                        c = b.outerHeight(!0);
                    b.css('min-height', c);
                });
        };
        return (a.accordions = { documentReady: e }), a.components.documentReady.push(e), a;
    })(mr, jQuery, window, document)),
    (mr = (function(a, b, c, d) {
        'use strict';
        var e = function(a) {
            a('.background-image-holder').each(function() {
                var b = a(this)
                    .children('img')
                    .attr('src');
                a(this)
                    .css('background', 'url("' + b + '")')
                    .css('background-position', 'initial')
                    .css('opacity', '1');
            });
        };
        return (a.backgrounds = { documentReady: e }), a.components.documentReady.push(e), a;
    })(mr, jQuery, window, document)),
    (mr = (function(a, b, c, d) {
        'use strict';
        return (
            (a.cookies = {
                getItem: function(a) {
                    return a
                        ? decodeURIComponent(
                              d.cookie.replace(
                                  new RegExp(
                                      '(?:(?:^|.*;)\\s*' +
                                          encodeURIComponent(a).replace(/[\-\.\+\*]/g, '\\$&') +
                                          '\\s*\\=\\s*([^;]*).*$)|^.*$'
                                  ),
                                  '$1'
                              )
                          ) || null
                        : null;
                },
                setItem: function(a, b, c, e, f, g) {
                    if (!a || /^(?:expires|max\-age|path|domain|secure)$/i.test(a)) return !1;
                    var h = '';
                    if (c)
                        switch (c.constructor) {
                            case Number:
                                h =
                                    c === 1 / 0
                                        ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT'
                                        : '; max-age=' + c;
                                break;
                            case String:
                                h = '; expires=' + c;
                                break;
                            case Date:
                                h = '; expires=' + c.toUTCString();
                        }
                    return (
                        (d.cookie =
                            encodeURIComponent(a) +
                            '=' +
                            encodeURIComponent(b) +
                            h +
                            (f ? '; domain=' + f : '') +
                            (e ? '; path=' + e : '') +
                            (g ? '; secure' : '')),
                        !0
                    );
                },
                removeItem: function(a, b, c) {
                    return this.hasItem(a)
                        ? ((d.cookie =
                              encodeURIComponent(a) +
                              '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' +
                              (c ? '; domain=' + c : '') +
                              (b ? '; path=' + b : '')),
                          !0)
                        : !1;
                },
                hasItem: function(a) {
                    return a
                        ? new RegExp(
                              '(?:^|;\\s*)' +
                                  encodeURIComponent(a).replace(/[\-\.\+\*]/g, '\\$&') +
                                  '\\s*\\='
                          ).test(d.cookie)
                        : !1;
                },
                keys: function() {
                    for (
                        var a = d.cookie
                                .replace(
                                    /((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g,
                                    ''
                                )
                                .split(/\s*(?:\=[^;]*)?;\s*/),
                            b = a.length,
                            c = 0;
                        b > c;
                        c++
                    )
                        a[c] = decodeURIComponent(a[c]);
                    return a;
                }
            }),
            a
        );
    })(mr, jQuery, window, document)),
    (mr = (function(a, b, c, d) {
        'use strict';
        a.forms = {};
        var e = function(b) {
            b('.input-checkbox').on('click', function() {
                var a = b(this);
                a.toggleClass('checked');
                var c = a.find('input');
                return c.prop('checked') === !1 ? c.prop('checked', !0) : c.prop('checked', !1), !1;
            }),
                b('.input-radio').on('click', function() {
                    var a = b(this);
                    return (
                        a
                            .closest('form')
                            .find('.input-radio')
                            .removeClass('checked'),
                        a
                            .addClass('checked')
                            .find('input')
                            .prop('checked', !0),
                        !1
                    );
                }),
                b('.input-file .btn').on('click', function() {
                    return (
                        b(this)
                            .siblings('input')
                            .trigger('click'),
                        !1
                    );
                }),
                b(
                    'form.form-email, form[action*="list-manage.com"], form[action*="createsend.com"]'
                )
                    .attr('novalidate', !0)
                    .unbind('submit')
                    .on('submit', a.forms.submit),
                b(d).on(
                    'change, input, paste, keyup',
                    '.attempted-submit .field-error',
                    function() {
                        b(this).removeClass('field-error');
                    }
                );
        };
        return (
            (a.forms.documentReady = e),
            (a.forms.submit = function(d) {
                d.preventDefault ? d.preventDefault() : (d.returnValue = !1);
                var e,
                    f,
                    g,
                    h,
                    i,
                    j = b('body'),
                    k = b(d.target).closest('form'),
                    l = 'undefined' != typeof k.attr('action') ? k.attr('action') : '',
                    m = k.find('button[type="submit"], input[type="submit"]'),
                    n = 0,
                    o = k.attr('original-error');
                if (
                    (j.find('.form-error, .form-success').remove(),
                    m.attr('data-text', m.text()),
                    (h = k.attr('data-error')
                        ? k.attr('data-error')
                        : 'Please fill all fields correctly'),
                    (i = k.attr('data-success')
                        ? k.attr('data-success')
                        : "Thanks, we'll be in touch shortly"),
                    j.append('<div class="form-error" style="display: none;">' + h + '</div>'),
                    j.append('<div class="form-success" style="display: none;">' + i + '</div>'),
                    (f = j.find('.form-error')),
                    (g = j.find('.form-success')),
                    k.addClass('attempted-submit'),
                    -1 !== l.indexOf('createsend.com') || -1 !== l.indexOf('list-manage.com'))
                )
                    if (
                        ('undefined' != typeof o && o !== !1 && f.html(o),
                        1 !== a.forms.validateFields(k))
                    ) {
                        k.removeClass('attempted-submit'),
                            f.fadeOut(200),
                            m.addClass('btn--loading');
                        try {
                            b.ajax({
                                url: k.attr('action'),
                                crossDomain: !0,
                                data: k.serialize(),
                                method: 'GET',
                                cache: !1,
                                dataType: 'json',
                                contentType: 'application/json; charset=utf-8',
                                success: function(b) {
                                    'success' !== b.result && 200 !== b.Status
                                        ? (f.attr('original-error', f.text()),
                                          f
                                              .html(b.msg)
                                              .stop(!0)
                                              .fadeIn(1e3),
                                          g.stop(!0).fadeOut(1e3),
                                          m.removeClass('btn--loading'))
                                        : (m.removeClass('btn--loading'),
                                          (e = k.attr('data-success-redirect')),
                                          'undefined' != typeof e && e !== !1 && '' !== e
                                              ? (c.location = e)
                                              : (a.forms.resetForm(k),
                                                a.forms.showFormSuccess(g, f, 1e3, 5e3, 500)));
                                }
                            });
                        } catch (p) {
                            f.attr('original-error', f.text()),
                                f.html(p.message),
                                a.forms.showFormError(g, f, 1e3, 5e3, 500),
                                m.removeClass('btn--loading');
                        }
                    } else a.forms.showFormError(g, f, 1e3, 5e3, 500);
                else
                    'undefined' != typeof o && o !== !1 && f.text(o),
                        (n = a.forms.validateFields(k)),
                        1 === n
                            ? a.forms.showFormError(g, f, 1e3, 5e3, 500)
                            : (k.removeClass('attempted-submit'),
                              f.fadeOut(200),
                              m.addClass('btn--loading'),
                              jQuery.ajax({
                                  type: 'POST',
                                  url: 'http://mailform.mediumra.re/pillar/mail.php',
                                  data: k.serialize() + '&url=' + c.location.href,
                                  success: function(d) {
                                      m.removeClass('btn--loading'),
                                          b.isNumeric(d)
                                              ? parseInt(d, 10) > 0 &&
                                                ((e = k.attr('data-success-redirect')),
                                                'undefined' != typeof e &&
                                                    e !== !1 &&
                                                    '' !== e &&
                                                    (c.location = e),
                                                a.forms.resetForm(k),
                                                a.forms.showFormSuccess(g, f, 1e3, 5e3, 500))
                                              : (f.attr('original-error', f.text()),
                                                f
                                                    .text(d)
                                                    .stop(!0)
                                                    .fadeIn(1e3),
                                                g.stop(!0).fadeOut(1e3));
                                  },
                                  error: function(a, b, c) {
                                      f.attr('original-error', f.text()),
                                          f
                                              .text(c)
                                              .stop(!0)
                                              .fadeIn(1e3),
                                          g.stop(!0).fadeOut(1e3),
                                          m.removeClass('btn--loading');
                                  }
                              }));
                return !1;
            }),
            (a.forms.validateFields = function(a) {
                var c,
                    d,
                    e = b(e);
                if (
                    (b(a)
                        .find('.validate-required[type="checkbox"]')
                        .each(function() {
                            b('[name="' + b(this).attr('name') + '"]:checked').length ||
                                ((d = 1),
                                (c = b(this)
                                    .attr('name')
                                    .replace('[]', '')),
                                e
                                    .find('.form-error')
                                    .text('Please tick at least one ' + c + ' box.'));
                        }),
                    b(a)
                        .find('.validate-required, .required, [required]')
                        .each(function() {
                            '' === b(this).val()
                                ? (b(this).addClass('field-error'), (d = 1))
                                : b(this).removeClass('field-error');
                        }),
                    b(a)
                        .find('.validate-email, .email, [name*="cm-"][type="email"]')
                        .each(function() {
                            /(.+)@(.+){2,}\.(.+){2,}/.test(b(this).val())
                                ? b(this).removeClass('field-error')
                                : (b(this).addClass('field-error'), (d = 1));
                        }),
                    a.find('.field-error').length)
                ) {
                    var f = b(a).find('.field-error:first');
                    f.length &&
                        b('html, body')
                            .stop(!0)
                            .animate({ scrollTop: f.offset().top - 100 }, 1200, function() {
                                f.focus();
                            });
                } else e.find('.form-error').fadeOut(1e3);
                return d;
            }),
            (a.forms.showFormSuccess = function(a, b, c, d, e) {
                a.stop(!0).fadeIn(c),
                    b.stop(!0).fadeOut(c),
                    setTimeout(function() {
                        a.stop(!0).fadeOut(e);
                    }, d);
            }),
            (a.forms.showFormError = function(a, b, c, d, e) {
                b.stop(!0).fadeIn(c),
                    a.stop(!0).fadeOut(c),
                    setTimeout(function() {
                        b.stop(!0).fadeOut(e);
                    }, d);
            }),
            (a.forms.resetForm = function(a) {
                (a = b(a)),
                    a.get(0).reset(),
                    a.find('.input-radio, .input-checkbox').removeClass('checked');
            }),
            a.components.documentReady.push(e),
            a
        );
    })(mr, jQuery, window, document)),
    (mr = (function(a, b, c, d) {
        'use strict';
        a.maps = {};
        var e = function(b) {
            b('.map-holder')
                .on('click', function() {
                    b(this).addClass('interact');
                })
                .removeClass('interact'),
                a.maps.initAPI(),
                a.maps.init();
        };
        return (
            (a.maps.documentReady = e),
            (a.maps.initAPI = function() {
                if (
                    d.querySelector('[data-maps-api-key]') &&
                    !d.querySelector('.gMapsAPI') &&
                    b('[data-maps-api-key]').length
                ) {
                    var a = d.createElement('script'),
                        c = b('[data-maps-api-key]:first').attr('data-maps-api-key');
                    (c = 'undefined' != typeof c ? c : ''),
                        '' !== c &&
                            ((a.type = 'text/javascript'),
                            (a.src =
                                'https://maps.googleapis.com/maps/api/js?key=' +
                                c +
                                '&callback=mr.maps.init'),
                            (a.className = 'gMapsAPI'),
                            d.body.appendChild(a));
                }
            }),
            (a.maps.init = function() {
                'undefined' != typeof c.google &&
                    'undefined' != typeof c.google.maps &&
                    b('.map-container[data-maps-api-key]').each(function() {
                        var a,
                            e,
                            f = this,
                            g = b(this),
                            h =
                                'undefined' != typeof g.attr('data-map-style')
                                    ? g.attr('data-map-style')
                                    : !1,
                            i =
                                JSON.parse(h) ||
                                [
                                    // {
                                    //     featureType: 'landscape',
                                    //     stylers: [
                                    //         { saturation: -100 },
                                    //         { lightness: 65 },
                                    //         { visibility: 'on' }
                                    //     ]
                                    // },
                                    // {
                                    //     featureType: 'poi',
                                    //     stylers: [
                                    //         { saturation: -100 },
                                    //         { lightness: 51 },
                                    //         { visibility: 'simplified' }
                                    //     ]
                                    // },
                                    // {
                                    //     featureType: 'road.highway',
                                    //     stylers: [{ saturation: -100 }, { visibility: 'simplified' }]
                                    // },
                                    // {
                                    //     featureType: 'road.arterial',
                                    //     stylers: [
                                    //         { saturation: -100 },
                                    //         { lightness: 30 },
                                    //         { visibility: 'on' }
                                    //     ]
                                    // },
                                    // {
                                    //     featureType: 'road.local',
                                    //     stylers: [
                                    //         { saturation: -100 },
                                    //         { lightness: 40 },
                                    //         { visibility: 'on' }
                                    //     ]
                                    // },
                                    // {
                                    //     featureType: 'transit',
                                    //     stylers: [{ saturation: -100 }, { visibility: 'simplified' }]
                                    // },
                                    // {
                                    //     featureType: 'administrative.province',
                                    //     stylers: [{ visibility: 'off' }]
                                    // },
                                    // {
                                    //     featureType: 'water',
                                    //     elementType: 'labels',
                                    //     stylers: [
                                    //         { visibility: 'on' },
                                    //         { lightness: -25 },
                                    //         { saturation: -100 }
                                    //     ]
                                    // },
                                    // {
                                    //     featureType: 'water',
                                    //     elementType: 'geometry',
                                    //     stylers: [
                                    //         { hue: '#ffff00' },
                                    //         { lightness: -25 },
                                    //         { saturation: -97 }
                                    //     ]
                                    // }
                                ],
                            j =
                                'undefined' != typeof g.attr('data-map-zoom') &&
                                '' !== g.attr('data-map-zoom')
                                    ? 1 * g.attr('data-map-zoom')
                                    : 17,
                            k =
                                'undefined' != typeof g.attr('data-latlong')
                                    ? g.attr('data-latlong')
                                    : !1,
                            l = k ? 1 * k.substr(0, k.indexOf(',')) : !1,
                            m = k ? 1 * k.substr(k.indexOf(',') + 1) : !1,
                            n = new google.maps.Geocoder(),
                            o =
                                'undefined' != typeof g.attr('data-address')
                                    ? g.attr('data-address').split(';')
                                    : [''],
                            p =
                                'undefined' != typeof g.attr('data-marker-image')
                                    ? g.attr('data-marker-image')
                                    : 'img/mapmarker.png',
                            q = 'We Are Here',
                            r = b(d).width() > 766 ? !0 : !1,
                            s = {
                                draggable: r,
                                scrollwheel: !1,
                                zoom: j,
                                disableDefaultUI: !0,
                                styles: i
                            };
                        'undefined' != typeof g.attr('data-marker-title') &&
                            '' !== g.attr('data-marker-title') &&
                            (q = g.attr('data-marker-title')),
                            void 0 !== o && '' !== o[0]
                                ? n.geocode({ address: o[0].replace('[nomarker]', '') }, function(
                                      a,
                                      b
                                  ) {
                                      if (b == google.maps.GeocoderStatus.OK) {
                                          var d = new google.maps.Map(f, s);
                                          d.setCenter(a[0].geometry.location),
                                              o.forEach(function(a) {
                                                  var b;
                                                  if (
                                                      ((p = {
                                                          url:
                                                              'undefined' == typeof c.mr_variant
                                                                  ? p
                                                                  : '../img/mapmarker.png',
                                                          scaledSize: new google.maps.Size(50, 50)
                                                      }),
                                                      /(\-?\d+(\.\d+)?),\s*(\-?\d+(\.\d+)?)/.test(
                                                          a
                                                      ))
                                                  )
                                                      var e = a.split(','),
                                                          f = new google.maps.Marker({
                                                              position: {
                                                                  lat: 1 * e[0],
                                                                  lng: 1 * e[1]
                                                              },
                                                              map: d,
                                                              icon: p,
                                                              title: q,
                                                              optimised: !1
                                                          });
                                                  else
                                                      a.indexOf('[nomarker]') < 0 &&
                                                          ((b = new google.maps.Geocoder()),
                                                          b.geocode(
                                                              {
                                                                  address: a.replace(
                                                                      '[nomarker]',
                                                                      ''
                                                                  )
                                                              },
                                                              function(a, b) {
                                                                  b ===
                                                                      google.maps.GeocoderStatus
                                                                          .OK &&
                                                                      (f = new google.maps.Marker({
                                                                          map: d,
                                                                          icon: p,
                                                                          title: q,
                                                                          position:
                                                                              a[0].geometry
                                                                                  .location,
                                                                          optimised: !1
                                                                      }));
                                                              }
                                                          ));
                                              });
                                      }
                                  })
                                : 'undefined' != typeof l &&
                                  '' !== l &&
                                  l !== !1 &&
                                  'undefined' != typeof m &&
                                  '' !== m &&
                                  m !== !1 &&
                                  ((s.center = { lat: l, lng: m }),
                                  (a = new google.maps.Map(g, s)),
                                  (e = new google.maps.Marker({
                                      position: { lat: l, lng: m },
                                      map: a,
                                      icon: p,
                                      title: q
                                  })));
                    });
            }),
            a.components.documentReady.push(e),
            a
        );
    })(mr, jQuery, window, document)),
    (mr = (function(a, b, c, d) {
        'use strict';
        var e = function(b) {
                b('.masonry').each(function() {
                    var c,
                        d = b(this),
                        e = d.find('.masonry__container'),
                        f = d.find('.masonry__filters'),
                        g =
                            'undefined' != typeof f.attr('data-filter-all-text')
                                ? f.attr('data-filter-all-text')
                                : 'All';
                    e.find('.masonry__item[data-masonry-filter]').length &&
                        (f.append('<ul></ul>'),
                        (c = f.find('> ul')),
                        e.find('.masonry__item[data-masonry-filter]').each(function() {
                            var d = b(this),
                                e = d.attr('data-masonry-filter'),
                                f = [];
                            'undefined' != typeof e && '' !== e && (f = e.split(',')),
                                jQuery(f).each(function(b, e) {
                                    var f = a.util.slugify(e, !0);
                                    d.addClass('filter-' + f),
                                        c.find('[data-masonry-filter="' + f + '"]').length ||
                                            c.append(
                                                '<li data-masonry-filter="' + f + '">' + e + '</li>'
                                            );
                                });
                        }),
                        a.util.sortChildrenByText(b(this).find('.masonry__filters ul')),
                        c.prepend('<li class="active" data-masonry-filter="*">' + g + '</li>'));
                });
            },
            f = function() {
                b('.masonry').each(function() {
                    var a = b(this).find('.masonry__container');
                    a.on('layoutComplete', function() {
                        a.addClass('masonry--active');
                    }),
                        a.isotope({
                            itemSelector: '.masonry__item',
                            masonry: { columnWidth: '.masonry__item' }
                        });
                }),
                    b('.masonry__filters li').on('click', function() {
                        var a = b(this),
                            c = a.closest('.masonry').find('.masonry__container'),
                            d = '*';
                        '*' !== a.attr('data-masonry-filter') &&
                            (d = '.filter-' + a.attr('data-masonry-filter')),
                            a.siblings('li').removeClass('active'),
                            a.addClass('active'),
                            c.removeClass('masonry--animate'),
                            c.isotope({ filter: d });
                    });
            };
        return (
            (a.masonry = { documentReady: e, windowLoad: f }),
            a.components.documentReady.push(e),
            a.components.windowLoad.push(f),
            a
        );
    })(mr, jQuery, window, document)),
    (mr = (function(a, b, c, d) {
        'use strict';
        a.modals = {};
        var e = function(b) {
            if (
                (b('.modal-container').each(function() {
                    var d = b(this),
                        e = b(c),
                        f = d.find('.modal-content');
                    if (
                        (d.find('.modal-close').length ||
                            d
                                .find('.modal-content')
                                .append('<div class="modal-close modal-close-cross"></div>'),
                        void 0 !== f.attr('data-width'))
                    ) {
                        var g =
                            1 * f.attr('data-width').substr(0, f.attr('data-width').indexOf('%'));
                        e.width() < 1280 && e.width() > 990
                            ? (g += 15)
                            : e.width() < 990 && (g += 20),
                            f.css('width', g + '%');
                    }
                    if (void 0 !== f.attr('data-height')) {
                        var h =
                            1 * f.attr('data-height').substr(0, f.attr('data-height').indexOf('%'));
                        e.height() < 768 && (h += 15), f.css('height', h + '%');
                    }
                    a.util.idleSrc(d, 'iframe');
                }),
                'undefined' == typeof mr_variant &&
                    b('.modal-instance').each(function(a) {
                        var c = b(this),
                            d = c.find('.modal-container'),
                            e = (c.find('.modal-content'), c.find('.modal-trigger'));
                        e.attr('data-modal-index', a),
                            d.attr('data-modal-index', a),
                            'undefined' != typeof d.attr('data-modal-id') &&
                                e.attr('data-modal-id', d.attr('data-modal-id')),
                            (d = d.detach()),
                            b('body').append(d);
                    }),
                b('.modal-trigger').on('click', function() {
                    var c,
                        d,
                        e = b(this),
                        f = b('body');
                    return (
                        'undefined' != typeof e.attr('data-modal-id')
                            ? ((c = e.attr('data-modal-id')),
                              (d = f.find('.modal-container[data-modal-id="' + c + '"]')))
                            : ((c = b(this).attr('data-modal-index')),
                              (d = f.find('.modal-container[data-modal-index="' + c + '"]'))),
                        a.util.activateIdleSrc(d, 'iframe'),
                        a.modals.autoplayVideo(d),
                        a.modals.showModal(d),
                        !1
                    );
                }),
                b('.modal-close').on('click', a.modals.closeActiveModal),
                b(d).keyup(function(b) {
                    27 == b.keyCode && a.modals.closeActiveModal();
                }),
                b('.modal-container').on('click', function(b) {
                    b.target == this && a.modals.closeActiveModal();
                }),
                b('.modal-container[data-autoshow]').each(function() {
                    var c = b(this),
                        d = 1 * c.attr('data-autoshow');
                    a.util.activateIdleSrc(c),
                        a.modals.autoplayVideo(c),
                        'undefined' != typeof c.attr('data-cookie')
                            ? a.cookies.hasItem(c.attr('data-cookie')) || a.modals.showModal(c, d)
                            : a.modals.showModal(c, d);
                }),
                2 == c.location.href.split('#').length)
            ) {
                var e = c.location.href.split('#').pop();
                b('[data-modal-id="' + e + '"]').length &&
                    (a.modals.closeActiveModal(),
                    a.modals.showModal(b('[data-modal-id="' + e + '"]')));
            }
            b(d).on(
                'wheel mousewheel scroll',
                '.modal-content, .modal-content .scrollable',
                function(a) {
                    a.preventDefault && a.preventDefault(),
                        a.stopPropagation && a.stopPropagation(),
                        (this.scrollTop += a.originalEvent.deltaY);
                }
            );
        };
        return (
            (a.modals.documentReady = e),
            (a.modals.showModal = function(a, b) {
                var c = 'undefined' != typeof b ? 1 * b : 0;
                setTimeout(function() {
                    a.addClass('modal-active');
                }, c);
            }),
            (a.modals.closeActiveModal = function() {
                var c = b('body div.modal-active');
                a.util.idleSrc(c, 'iframe'),
                    a.util.pauseVideo(c),
                    'undefined' != typeof c.attr('data-cookie') &&
                        a.cookies.setItem(c.attr('data-cookie'), 'true', 1 / 0),
                    c.removeClass('modal-active');
            }),
            (a.modals.autoplayVideo = function(a) {
                if (a.find('video[autoplay]').length) {
                    var b = a.find('video').get(0);
                    b.play();
                }
            }),
            a.components.documentReady.push(e),
            a
        );
    })(mr, jQuery, window, document)),
    (mr = (function(a, b, c, d) {
        'use strict';
        (a.navigation = {}), (a.navigation.nav = {}), (a.navigation.bar = {});
        var e = function(b) {
            (a.navigation.nav.element = b('nav')),
                (a.navigation.bar.element = b('nav .nav-bar')),
                a.navigation.nav.element.length
                    ? (a.navigation.nav.outerHeight = a.navigation.nav.element.outerHeight())
                    : (a.navigation.nav.outerHeight = 0),
                a.navigation.bar.element.length && a.navigation.bar.init(),
                b('.nav-mobile-toggle').on('click', function() {
                    b('nav').toggleClass('nav-open');
                }),
                b('.menu li').on('click', function(a) {
                    var d = b(this),
                        e = a || c.event;
                    e.stopPropagation(),
                        d.find('ul').length
                            ? d.toggleClass('active')
                            : d.parents('.active').removeClass('active');
                }),
                b('.module-applet').on('click', function() {
                    b(this).toggleClass('active');
                }),
                b('.module-applet__body').each(function() {
                    var a = b(this),
                        d = a.offset().left + a.outerWidth();
                    d > b(c).width() && a.addClass('pos-right');
                }),
                b('.menu > li > ul').each(function() {
                    var a = b(c),
                        d = b(this),
                        e = d.offset(),
                        f = e.left + d.outerWidth(!0),
                        g = a.width(),
                        h = d.hasClass('multi-column');
                    if (f > g && !h) d.addClass('make-right');
                    else if (f > g && h) {
                        var i = f - g;
                        d.css('margin-left', -i);
                    }
                });
        };
        return (
            (a.navigation.bar.init = function() {
                var b = a.navigation.bar.element.attr('data-fixed-at');
                (a.navigation.bar.fixedAt =
                    'undefined' != typeof b ? parseInt(b.replace('px', ''), 10) : !1),
                    a.navigation.bar.element.hasClass('nav--fixed')
                        ? (a.navigation.bar.isFixed = !0)
                        : b &&
                          (a.navigation.nav.element.css('min-height', a.navigation.nav.outerHeight),
                          (a.navigation.bar.isFixed = !1),
                          a.scroll.listeners.push(a.navigation.bar.update));
            }),
            (a.navigation.bar.update = function() {
                a.scroll.y > a.navigation.bar.fixedAt &&
                    !a.navigation.bar.isFixed &&
                    ((a.navigation.bar.isFixed = !0),
                    a.navigation.bar.element.addClass('nav--fixed')),
                    a.scroll.y < a.navigation.bar.fixedAt &&
                        a.navigation.bar.isFixed &&
                        ((a.navigation.bar.isFixed = !1),
                        a.navigation.bar.element.removeClass('nav--fixed'));
            }),
            (a.navigation.documentReady = e),
            a.components.documentReady.push(e),
            a
        );
    })(mr, jQuery, window, document)),
    (mr = (function(a, b, c, d) {
        'use strict';
        a.newsletters = {};
        var e = function(b) {
            var c, d, e, f, g, h;
            b('form[action*="createsend.com"]').each(function() {
                (c = b(this)),
                    c.attr('novalidate', 'novalidate'),
                    c.is('.form--no-placeholders')
                        ? c.find('input[placeholder]').removeAttr('placeholder')
                        : c.find('input:not([checkbox]):not([radio])').each(function() {
                              var a = b(this);
                              'undefined' != typeof a.attr('placeholder')
                                  ? '' === a.attr('placeholder') &&
                                    a.siblings('label').length &&
                                    (a.attr(
                                        'placeholder',
                                        a
                                            .siblings('label')
                                            .first()
                                            .text()
                                    ),
                                    c.is('.form--no-labels') &&
                                        a
                                            .siblings('label')
                                            .first()
                                            .remove())
                                  : a.siblings('label').length &&
                                    (a.attr(
                                        'placeholder',
                                        a
                                            .siblings('label')
                                            .first()
                                            .text()
                                    ),
                                    c.is('.form--no-labels') &&
                                        a
                                            .siblings('label')
                                            .first()
                                            .remove()),
                                  a.parent().is('p') && a.unwrap();
                          }),
                    c.find('select').wrap('<div class="input-select"></div>'),
                    c.find('input[type="radio"]').wrap('<div class="input-radio"></div>'),
                    c.find('input[type="checkbox"]').each(function() {
                        (d = b(this)),
                            (f = d.attr('id')),
                            (e = c.find('label[for=' + f + ']')),
                            d.before('<div class="input-checkbox" data-id="' + f + '"></div>'),
                            b('.input-checkbox[data-id="' + f + '"]').prepend(d),
                            b('.input-checkbox[data-id="' + f + '"]').prepend(e),
                            b('.input-checkbox[data-id="' + f + '"]').prepend(
                                '<div class="inner"></div>'
                            );
                    }),
                    c.find('button[type="submit"]').each(function() {
                        var a = b(this);
                        a.addClass('btn'), a.parent().is('p') && a.unwrap();
                    }),
                    c
                        .find('[required]')
                        .removeAttr('required')
                        .addClass('validate-required'),
                    c.addClass('form--active'),
                    a.newsletters.prepareAjaxAction(c);
            }),
                b('form[action*="list-manage.com"]').each(function() {
                    (c = b(this)),
                        c.attr('novalidate', 'novalidate'),
                        c.is('.form--no-placeholders')
                            ? c.find('input[placeholder]').removeAttr('placeholder')
                            : c.find('input:not([checkbox]):not([radio])').each(function() {
                                  var a = b(this);
                                  'undefined' != typeof a.attr('placeholder')
                                      ? '' === a.attr('placeholder') &&
                                        a.siblings('label').length &&
                                        (a.attr(
                                            'placeholder',
                                            a
                                                .siblings('label')
                                                .first()
                                                .text()
                                        ),
                                        c.is('.form--no-labels') &&
                                            a
                                                .siblings('label')
                                                .first()
                                                .remove())
                                      : a.siblings('label').length &&
                                        (a.attr(
                                            'placeholder',
                                            a
                                                .siblings('label')
                                                .first()
                                                .text()
                                        ),
                                        c.is('.form--no-labels') &&
                                            a
                                                .siblings('label')
                                                .first()
                                                .remove());
                              }),
                        c.is('.form--no-labels') &&
                            c.find('input:not([checkbox]):not([radio])').each(function() {
                                var a = b(this);
                                a.siblings('label').length &&
                                    a
                                        .siblings('label')
                                        .first()
                                        .remove();
                            }),
                        c.find('select').wrap('<div class="input-select"></div>'),
                        c.find('input[type="checkbox"]').each(function() {
                            (d = b(this)),
                                (g = d.closest('li')),
                                (e = g.find('label')),
                                d.before(
                                    '<div class="input-checkbox"><div class="inner"></div></div>'
                                ),
                                g.find('.input-checkbox').prepend(d),
                                g.find('.input-checkbox').prepend(e);
                        }),
                        c.find('input[type="radio"]').each(function() {
                            (h = b(this)),
                                (g = h.closest('li')),
                                (e = g.find('label')),
                                h.before(
                                    '<div class="input-radio"><div class="inner"></div></div>'
                                ),
                                g.find('.input-radio').prepend(h),
                                g.find('.input-radio').prepend(e);
                        }),
                        c.find('input[type="submit"]').each(function() {
                            var a = b(this),
                                c = jQuery('<button/>')
                                    .attr('type', 'submit')
                                    .attr('class', a.attr('class'))
                                    .addClass('btn')
                                    .text(a.attr('value'));
                            a.parent().is('div.clear') && a.unwrap(), c.insertBefore(a), a.remove();
                        }),
                        c.find('input').each(function() {
                            var a = b(this);
                            a.hasClass('required') &&
                                a.removeClass('required').addClass('validate-required');
                        }),
                        c
                            .find('input[type="email"]')
                            .removeClass('email')
                            .addClass('validate-email'),
                        c.find('#mce-responses').remove(),
                        c.find('.mc-field-group').each(function() {
                            b(this)
                                .children()
                                .first()
                                .unwrap();
                        }),
                        c
                            .find('[required]')
                            .removeAttr('required')
                            .addClass('validate-required'),
                        c.addClass('form--active'),
                        a.newsletters.prepareAjaxAction(c);
                }),
                a.forms.documentReady(a.setContext('form.form--active'));
        };
        return (
            (a.newsletters.documentReady = e),
            (a.newsletters.prepareAjaxAction = function(a) {
                var c = b(a).attr('action');
                /list-manage\.com/.test(c) &&
                    ((c = c.replace('/post?', '/post-json?') + '&c=?'),
                    '//' == c.substr(0, 2) && (c = 'http:' + c)),
                    /createsend\.com/.test(c) && (c += '?callback=?'),
                    b(a).attr('action', c);
            }),
            a.components.documentReady.push(e),
            a
        );
    })(mr, jQuery, window, document)),
    (mr = (function(a, b, c, d) {
        'use strict';
        a.notifications = {};
        var e = function(b) {
            b('.notification').each(function() {
                var a = b(this);
                a.find('.notification-close').length ||
                    a.append('<div class="notification-close-cross notification-close"></div>');
            }),
                b('.notification[data-autoshow]').each(function() {
                    var c = b(this),
                        d = 1 * c.attr('data-autoshow');
                    'undefined' != typeof c.attr('data-cookie')
                        ? a.cookies.hasItem(c.attr('data-cookie')) ||
                          a.notifications.showNotification(c, d)
                        : a.notifications.showNotification(c, d);
                }),
                b('[data-notification-link]:not(.notification)').on('click', function() {
                    var c = b(this).attr('data-notification-link'),
                        d = b('body').find('.notification[data-notification-link="' + c + '"]');
                    return (
                        d.removeClass('notification--dismissed'),
                        a.notifications.showNotification(d, 0),
                        !1
                    );
                }),
                b('.notification-close').on('click', function() {
                    var c = b(this);
                    return (
                        a.notifications.closeNotification(c), '#' === c.attr('href') ? !1 : void 0
                    );
                });
        };
        return (
            (a.notifications.documentReady = e),
            (a.notifications.showNotification = function(a, b) {
                var c = 'undefined' != typeof b ? 1 * b : 0;
                setTimeout(function() {
                    a.addClass('notification--reveal'),
                        a.closest('nav').addClass('notification--reveal'),
                        a.find('input').length &&
                            a
                                .find('input')
                                .first()
                                .focus();
                }, c);
            }),
            (a.notifications.closeNotification = function(c) {
                var d = b(c);
                (c = d.is('.notification-close')
                    ? d.closest('.notification')
                    : b('body').find('.notification[data-notification-link="' + c + '"]')),
                    c.addClass('notification--dismissed'),
                    c.closest('nav').removeClass('notification--reveal'),
                    'undefined' != typeof c.attr('data-cookie') &&
                        a.cookies.setItem(c.attr('data-cookie'), 'true', 1 / 0);
            }),
            a.components.documentReady.push(e),
            a
        );
    })(mr, jQuery, window, document)),
    (mr = (function(a, b, c, d) {
        'use strict';
        var e = function(a) {
            var b = a(c),
                d = b.width(),
                e = b.height(),
                f = a('nav').outerHeight(!0);
            if (
                (/Android|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(
                    navigator.userAgent || navigator.vendor || c.opera
                ) && a('section').removeClass('parallax'),
                d > 768)
            ) {
                var g = a('.parallax:nth-of-type(1)'),
                    h = a('.parallax:nth-of-type(1) .background-image-holder');
                h.css('top', -f), g.outerHeight(!0) == e && h.css('height', e + f);
            }
        };
        return (a.parallax = { documentReady: e }), a.components.documentReady.push(e), a;
    })(mr, jQuery, window, document)),
    (mr = (function(a, b, c, d) {
        'use strict';
        var e = function(a) {
            a('.barchart').each(function() {
                var b = a(this),
                    c = b.find('.barchart__progress'),
                    d = 1 * b.attr('data-value') + '%';
                c.attr('data-value', d),
                    b.hasClass('barchart--vertical') ? c.css('height', d) : c.css('width', d);
            });
        };
        return (a.piecharts = { documentReady: e }), a.components.documentReady.push(e), a;
    })(mr, jQuery, window, document)),
    (mr = (function(a, b, c, d) {
        'use strict';
        var e = function(a) {
            a('.piechart').each(function() {
                var b = a(this),
                    c = 1 * b.attr('data-value');
                b.easyPieChart({ animate: 2e3, barColor: '#425cbb' }),
                    b.data('easyPieChart').update(c);
            });
        };
        return (a.easypiecharts = { documentReady: e }), a.components.documentReady.push(e), a;
    })(mr, jQuery, window, document)),
    (mr = (function(a, b, c, d) {
        'use strict';
        var e = function(a) {
            var b = a('body');
            if (a('body[data-reveal-selectors]').length) {
                c.sr = ScrollReveal();
                var d = b.attr('data-reveal-selectors'),
                    e = 1e3;
                a('body[data-reveal-timing]').length && (e = b.attr('data-reveal-timing')),
                    c.sr.reveal('' + d, {
                        viewFactor: 0.1,
                        duration: '' + e,
                        scale: 1,
                        mobile: !1
                    });
            }
        };
        return (a.scrollreveal = { documentReady: e }), a.components.documentReady.push(e), a;
    })(mr, jQuery, window, document)),
    (mr = (function(a, b, c, d) {
        'use strict';
        a.sliders = {};
        var e = function(b) {
            var c = [];
            b('.slider').each(function() {
                var a = b(this);
                if (a.find('ul.slides').length) return !0;
                var c = [];
                a.find('>*').length;
                a.children().each(function(a) {
                    c.push(
                        b(this)
                            .wrap('<li>')
                            .parent()
                    );
                }),
                    b('<ul class="slides"></ul>')
                        .append(c)
                        .appendTo(a);
            }),
                b('.slider').each(function(a) {
                    var d = b(this),
                        e = b(this).find('ul.slides'),
                        f = 1,
                        g = !1,
                        h = !1,
                        i = 7e3,
                        j = !1,
                        k = !0;
                    (g = 'true' == d.attr('data-arrows') ? !0 : !1),
                        (k = 'false' == d.attr('data-autoplay') ? !1 : !0),
                        (h = 'true' == d.attr('data-paging') && e.find('li').length > 1 ? !0 : !1),
                        d.attr('data-timing') && (i = d.attr('data-timing')),
                        d.attr('data-items') && (f = d.attr('data-items')),
                        e.find('li').length > 1 && 'false' != d.attr('data-loop') && (j = !0),
                        c.push(e),
                        c[a].owlCarousel({
                            nav: g,
                            dots: h,
                            dotsSpeed: 500,
                            navSpeed: 500,
                            items: f,
                            autoplay: k,
                            autoplayTimeout: i,
                            navText: !1,
                            loop: j,
                            mouseDrag: !1,
                            responsive: { 0: { items: 1 }, 768: { items: f } }
                        });
                }),
                (a.sliders.sliders = c);
        };
        return (a.sliders.documentReady = e), a.components.documentReadyDeferred.push(e), a;
    })(mr, jQuery, window, document)),
    (mr = (function(a, b, c, d) {
        'use strict';
        var e = function(a) {
            var b = a('a.inner-link');
            if (b.length) {
                b.each(function() {
                    var b = a(this),
                        c = b.attr('href');
                    '#' !== c.charAt(0) && b.removeClass('inner-link');
                });
                var c = 0;
                a('body[data-smooth-scroll-offset]').length &&
                    ((c = a('body').attr('data-smooth-scroll-offset')), (c = 1 * c)),
                    smoothScroll.init({
                        selector: '.inner-link',
                        selectorHeader: null,
                        speed: 750,
                        easing: 'easeInOutCubic',
                        offset: c
                    });
            }
        };
        return (a.smoothscroll = { documentReady: e }), a.components.documentReady.push(e), a;
    })(mr, jQuery, window, document)),
    (mr = (function(a, b, c, d) {
        'use strict';
        var e = function(a) {
            a('.tabs').each(function() {
                var b = a(this);
                b.after('<ul class="tabs-content">'),
                    b.find('li').each(function() {
                        var b = a(this),
                            c = b
                                .find('.tab__content')
                                .wrap('<li></li>')
                                .parent(),
                            d = c.clone(!0, !0);
                        c.remove(),
                            b
                                .closest('.tabs-container')
                                .find('.tabs-content')
                                .append(d);
                    });
            }),
                a('.tabs li').on('click', function() {
                    var b = a(this),
                        c = b.closest('.tabs-container'),
                        d = 1 * b.index() + 1;
                    c.find('> .tabs > li').removeClass('active'),
                        c.find('> .tabs-content > li').removeClass('active'),
                        b.addClass('active'),
                        c.find('> .tabs-content > li:nth-of-type(' + d + ')').addClass('active');
                }),
                a('.tabs li.active').trigger('click');
        };
        return (a.tabs = { documentReady: e }), a.components.documentReady.push(e), a;
    })(mr, jQuery, window, document)),
    $(window).bind('pageshow', function(a) {
        a.originalEvent.persisted && window.location.reload();
    }),
    (mr = (function(a, b, c, d) {
        'use strict';
        var e = function(a) {
                a(
                    'a:not([href^="#"]):not([href^="tel"]):not([href^="mailto"]):not([data-lightbox]):not([href=""]):not([target="_blank"]):not(.modal-trigger):not([class*="lb-"])'
                ).on('click', function() {
                    a('[class*="transition--"]').removeClass('transition--active');
                });
            },
            f = function() {
                b('[class*="transition--"]').addClass('transition--active'),
                    b('.loader').addClass('loader--fade');
            };
        return (
            (a.transitions = { documentReady: e, windowLoad: f }),
            a.components.documentReady.push(e),
            a.components.windowLoad.push(f),
            a
        );
    })(mr, jQuery, window, document)),
    (mr = (function(a, b, c, d) {
        'use strict';
        var e = function(b) {
            b('.tweets-feed')
                .each(function(a) {
                    b(this).attr('id', 'tweets-' + a);
                })
                .each(function(c) {
                    function d(b) {
                        for (var c = b.length, d = 0, f = '<ul class="slides">'; c > d; )
                            (f += '<li>' + b[d] + '</li>'), d++;
                        return (
                            (f += '</ul>'),
                            e.html(f),
                            e.closest('.slider').length
                                ? (a.sliders.documentReady(a.setContext()), f)
                                : void 0
                        );
                    }
                    var e = b('#tweets-' + c),
                        f = {
                            domId: '',
                            maxTweets: e.attr('data-amount'),
                            enableLinks: !0,
                            showUser: !0,
                            showTime: !0,
                            dateFunction: '',
                            showRetweet: !1,
                            customCallback: d
                        };
                    'undefined' != typeof e.attr('data-widget-id')
                        ? (f.id = e.attr('data-widget-id'))
                        : 'undefined' != typeof e.attr('data-feed-name')
                          ? (f.profile = { screenName: e.attr('data-feed-name') })
                          : (f.profile = { screenName: 'twitter' }),
                        e.closest('.twitter-feed--slider').length && e.addClass('slider'),
                        twitterFetcher.fetch(f);
                });
        };
        return (a.twitter = { documentReady: e }), a.components.documentReady.push(e), a;
    })(mr, jQuery, window, document)),
    (mr = (function(a, b, c, d) {
        'use strict';
        var e = function(a) {
            a('.youtube-background').length &&
                a('.youtube-background').each(function() {
                    var b = a(this),
                        c = a(this).attr('data-video-url'),
                        d = a(this).attr('data-start-at');
                    b.attr(
                        'data-property',
                        '{videoURL:"' +
                            c +
                            '",containment:"self",autoPlay:true, mute:true, startAt:' +
                            d +
                            ', opacity:1}'
                    ),
                        b.closest('.videobg').append('<div class="loading-indicator"></div>'),
                        b.YTPlayer(),
                        b.on('YTPStart', function() {
                            b.closest('.videobg').addClass('video-active');
                        });
                }),
                a('.videobg').find('video').length &&
                    a('.videobg')
                        .find('video')
                        .closest('.videobg')
                        .addClass('video-active'),
                a('.video-cover').each(function() {
                    var b = a(this);
                    b.find('iframe').length &&
                        (b.find('iframe').attr('data-src', b.find('iframe').attr('src')),
                        b.find('iframe').attr('src', ''));
                }),
                a('.video-cover .video-play-icon').on('click', function() {
                    var b = a(this),
                        c = b.closest('.video-cover');
                    if (c.find('video').length) {
                        var d = c.find('video').get(0);
                        return c.addClass('reveal-video'), d.play(), !1;
                    }
                    if (c.find('iframe').length) {
                        var e = c.find('iframe');
                        return e.attr('src', e.attr('data-src')), c.addClass('reveal-video'), !1;
                    }
                });
        };
        return (a.video = { documentReady: e }), a.components.documentReady.push(e), a;
    })(mr, jQuery, window, document));
// (function(a, b, c, d, e, f, g) {
//     (a.GoogleAnalyticsObject = e),
//         (a[e] =
//             a[e] ||
//             function() {
//                 (a[e].q = a[e].q || []).push(arguments);
//             }),
//         (a[e].l = 1 * new Date()),
//         (f = b.createElement(c)),
//         (g = b.getElementsByTagName(c)[0]),
//         (f.async = 1),
//         (f.src = d),
//         g.parentNode.insertBefore(f, g);
// })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga'),
// ga('create', 'UA-52115242-5', 'auto'),
// ga('send', 'pageview');
